wbApp.directive('wbDependentPropertyRequiredValidator', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            wbDependentPropertyRequiredValidator: '='
        },
        link: function (scope, elem, attr, ctrl) {

            function validate(value1, value2) {
                var val2Def = !!value2 && value2 != '0';
                var val1Def = !!value1;

                ctrl.$setValidity('dependentPropertyRequired', (!!val1Def && !!val2Def) || !val2Def);
            }

            scope.$watch('wbDependentPropertyRequiredValidator', function (model) {
                validate(ctrl.$viewValue, model);
            });

            ctrl.$parsers.unshift(function (model) {
                validate(model, scope.wbDependentPropertyRequiredValidator);

                return model;
            });
        }
    };
}]);